import styled from 'styled-components';

export const IconAssetDefaultStyled = styled.div`
    background: var(--color-neutral-40);
    color: var(--color-white);
    display: flex;
    justify-content: center;
    align-items: center;
    span {
        font-size: 0.5em;
    }
`;
